import TeachingLearningSequenceInlineSvg from 'approot/shared/inline-svg/teaching-learning-sequence/teaching-learning-sequence-inline-svg';
import DifferentiationShape from 'approot/shared/differentiation/differentiation-shape';
import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';
import { AnchorStyled, PStyled } from 'approot/shared/styles/typography.style';
import { HrStyled } from 'approot/shared/styles/decorative.style';
import { getDifferentiationHeading } from 'approot/shared/differentiation/differentiation.utils';
import { isDifferentiatedAssessmentActivity } from 'approot/shared/logic/is-differentiated-assessment-activity';
import { getDifferentiationBlogLink } from 'approot/shared/logic/get-differentiation-blog-link';
import { getDifferentiationDescription } from './activity-view-details.utils';
import { useRegionData } from 'approot/shared/region/region.apollo';
import * as Styled from './activity-view-details.style';
import { getRegionalisedLink } from 'approot/shared/logic/get-regionalised-link';
import { useDifferentiationTranslation } from 'approot/shared/differentiation/use-differentiation-translation';

type Props = {
  differentiation: Differentiation | null;
  isCheckPoint: boolean;
  currentStep: number;
  totalSteps: number;
  progressLabel: string;
};

const ActivityViewDetails = ({
  differentiation,
  isCheckPoint,
  currentStep,
  totalSteps,
  progressLabel,
}: Props) => {
  const { unitQuizLabel, unitQuizDescription } =
    useDifferentiationTranslation();
  const { isRegionAU } = useRegionData();

  return (
    <Styled.ActivityViewDetails>
      <Styled.ActivityViewDetailsContent>
        {differentiation && (
          <>
            <Styled.ActivityViewDetailsTitle>
              <span>
                {isDifferentiatedAssessmentActivity(differentiation)
                  ? `${getDifferentiationHeading(
                      differentiation,
                      unitQuizLabel
                    )} Activity`
                  : `Differentiation: ${getDifferentiationHeading(
                      differentiation,
                      unitQuizLabel
                    )}`}
              </span>
              <DifferentiationShape
                isSmall
                differentiation={differentiation}
                width={16}
                height={16}
              />
            </Styled.ActivityViewDetailsTitle>
            <PStyled>
              {getDifferentiationDescription(
                differentiation,
                unitQuizDescription
              )}
            </PStyled>
            {!isDifferentiatedAssessmentActivity(differentiation) && (
              <PStyled>
                <AnchorStyled
                  href={getRegionalisedLink(
                    getDifferentiationBlogLink({ isRegionAU })
                  )}
                  target="_blank"
                  $fontWeight="normal"
                >
                  Learn about Differentiation with Inquisitive
                </AnchorStyled>
              </PStyled>
            )}
          </>
        )}

        {isCheckPoint && (
          <>
            <HrStyled $marginBottom={16} />
            <Styled.ActivityViewDetailsTitle>
              <span>Checkpoint Question</span>
              <TeachingLearningSequenceInlineSvg
                id="icon_star"
                height={16}
                width={16}
              />
            </Styled.ActivityViewDetailsTitle>
            <PStyled>
              A checkpoint question is an opportunity for Formative Assessment.
            </PStyled>
          </>
        )}

        {totalSteps > 1 && (
          <>
            <HrStyled $marginBottom={16} />
            <Styled.ActivityViewDetailsTitle>
              {progressLabel}
            </Styled.ActivityViewDetailsTitle>
            <PStyled>
              This is slide {currentStep} of an activity that goes across{' '}
              {totalSteps} slides in total.{' '}
            </PStyled>
          </>
        )}
      </Styled.ActivityViewDetailsContent>
    </Styled.ActivityViewDetails>
  );
};

export default ActivityViewDetails;
